import { Box, Divider, Stack } from '@mui/material';

import { TerminGenerellerKommentarCard, TerminPlanungsinformationenCard, ThemaSummary } from '../../components/general';
import { DurchgaengeList } from '../../components/general/DurchgaengeList';
import { VeranstaltungenList } from '../../components/general/VeranstaltungenList';
import { type ThemaFromThemaRouter } from '../../dtos';
import { trpc } from '../../trpc';
import { isTermingruppe } from '../../utils/isTermingruppe';
import { TerminZeitlicherAblaufCard } from '../ThemaDetailsPage/TerminZeitlicherAblaufCard';
import { ModuleSection } from './ModuleSection';

type VeranstaltungPlanungSidebarProps = {
  readonly thema: ThemaFromThemaRouter;
};

export const VeranstaltungPlanungSidebar = ({ thema }: VeranstaltungPlanungSidebarProps) => {
  const veranstaltungen = trpc.veranstaltung.getVeranstaltungenByAkaThemaIds.useQuery([
    thema.akaThemaId,
    ...thema.pendantThemen.map((pendant) => pendant.akaThemaId),
  ]);

  return (
    <Stack spacing={2}>
      <ThemaSummary thema={thema} showTitle />
      <Box sx={{ border: '1px solid', borderColor: 'border.default', borderRadius: '8px', pt: 0.5, pb: 0.5 }}>
        <TerminPlanungsinformationenCard thema={thema} bordered={false} isPlanung />
        <Divider sx={{ mx: 2 }} />
        <TerminGenerellerKommentarCard thema={thema} bordered={false} />
        <Divider sx={{ mx: 2 }} />

        {isTermingruppe(thema.planungsformat) ? (
          <>
            <ModuleSection module={thema.module} />
            <Divider sx={{ mx: 2 }} />
            <DurchgaengeList thema={thema} />
          </>
        ) : (
          <>
            <VeranstaltungenList veranstaltungen={veranstaltungen} thema={thema} />
            <Divider sx={{ mx: 2 }} />
            <TerminZeitlicherAblaufCard thema={thema} bordered={false} />
          </>
        )}
      </Box>
    </Stack>
  );
};
